/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scissors'
export default icon
